import { useContext } from 'react';

import { ConfirmContext, type ConfirmContextProps } from './ConfirmContext';

export const useConfirmDialog = (): ConfirmContextProps => {
  const confirm = useContext(ConfirmContext);

  return confirm;
};
